
// dev test and live urls

// const url='mlsliveapi.dosystemsinc.com';
const url='mlsliveapi.dosystemsinc.com';
// const url='mlstestapi.dosystemsinc.com';

const config = {

  apiUrl: `https://${url}/api/`,
  imgUrl: `https://${url}/images/attachment/`,
  resolutionUrl: `https://${url}/images/newResolutions/`,
  profileUrl: `https://${url}/images/attachment/agents/`,

  // apiUrl: 'http://localhost:12848/api/',
  // imgUrl: 'http://localhost:12848/images/attachment/',
  // resolutionUrl: 'http://localhost:12848/images/newResolutions/',
  // profileUrl: 'http://localhost:12848/images/agents/',

  socketUrl: 'https://api.school.dosystemsinc.com',
  janusUrl: 'wss://janus.dosystemsinc.com:8989/janus',
  serverErrMessage: 'Could Not reach server',

  //regex
  borderValidation: false,
  messages: true,

  entityType: 'agents',

  appName: 'Multiplelistingservice5',
  defaultScreen: "agents",
  displayProjectName: true,
  displayRecaptcha: false,
  displayGoogleLogin: false,
  loginName: 'Agents',
  selectedLoginScreenName: "1",
  pageLimit: '20',
  emailRegex: /^(?=.{1,50}$)[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/,
  passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/,
  aadharcardNumberRegex: /^([0-9]){12}$/,
  pancardNumberRegex: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  phoneNumberRegex: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
  userNameRegex: /^[a-zA-Z\s]{1,30}$/,
  lastNameRegex: /^[a-zA-Z\s]{1,30}$/,
  subjectRegex: /^[a-zA-Z\s]{1,50}$/,
  companyRegex: /^([A-Za-z0-9\s@.,]){1,30}$/,
  roomIdRegex: /^([0-9]){4,10}$/,
  // server response codes
  updateResCode: 205,
  deleteResCode: 206,

  datePlaceholder: '--/--/----',
  dateFormat: 'DD-MM-YYYY',
  dateTabularFormat: 'MMM DD YYYY',
  dateDisplayModalFormat: 'DD MMM YYYY',
  dateDBFormat: 'MM-DD-YYYY',
  dateDayMonthFormat: 'DD-MM-YYYY',
  dateYearMonthFormat: 'YYYY-MM-DD',
  dayYearDateFormat: 'YYYY-MM-DD',
  basicDateFromat: 'MM-DD-YYYY HH:mm A',
  descDateFromat: 'MMM DD YYYY HH:mm A',
  customDateFormat:'DD-MM-YYYY HH:mm',
  dateMonthFormat: 'DD/MMM',
  timeFormat: 'h:mm A',

  timeFormat: 'HH:mm',
  syncTimeFormat: 'hh:mm A, MM-DD-YYYY',
  lastModifiedDateFormat: 'MM/DD/YYYY HH:mm',
  dateTimeFormat: 'MM/DD/YYYY hh:mm',
  fullDateFormat: 'YYYY-MM-DD HH:mm:ss',
  fullDateTimeFormat: 'YYYY-MM-DD[T]HH:mm:ss.SSZ',
  dbDateFormat: 'YYYY-MM-DD[T]HH:mm:ss.SSZ',
  dbOnlyDateFormat: 'YYYY-MM-DD[T]00:00:00Z',
  ESTTimezone: "America/New_York",
  formFieldStatusTypes: [
    { label: "Active", value: "Active" },
    { label: "Pending", value: "Pending" },
    { label: "Inactive", value: "Inactive" }
  ],
  noView: 'noView',
  edit: 'edit',
  
  bedRoomOptions:[
    { label: "0", value: "0", id: "msr" },
    { label: "1", value: "1", id: "msr" },
    { label: "1.5", value: "1.5", id: "msr" },
    { label: "2", value: "2", id: "msr" },
    { label: "2.5", value: "2.5", id: "msr" },
    { label: "3", value: "3", id: "msr" },
    { label: "3.5", value: "3.5", id: "msr" },
    { label: "4", value: "4", id: "msr" },
    { label: "4.5", value: "4.5", id: "msr" },
    { label: "5", value: "5", id: "msr" },
    { label: "5.5", value: "5.5", id: "msr" },
    { label: "6", value: "6", id: "msr" },
    { label: "6.5", value: "6.5", id: "msr" },
  ],
  bathRoomOptions:[
    { label: "0", value: "0", id: "msr" },
    { label: "1", value: "1", id: "msr" },
    { label: "2", value: "2", id: "msr" },
    { label: "3", value: "3", id: "msr" },
    { label: "4", value: "4", id: "msr" },
  ],
  // templateColor: '#0e4768',
  whiteColor: '#ffffff',
  darkTemplateColor: '#00000045',
  avatarBgColor: 'green',
  blackColor: 'black',
  sourceKey: "qVtYv2x5A7CaFcHeMh",
  paginationPosition: 'top',
  displaySettings: true,
  selectionLimit: 30,
  imageFormats: ['.png', '.apng', '.avif', '.jpg', '.jpeg', '.gif', '.bmp', '.svg', '.tiff', '.webp', '.jfif', '.pjpeg', '.pjp'],
  buttonRequired: false,
  stylingOnHover:{
    color: '#0e4768',
    fontWeight: 'bold',
    textDecoration: 'underline',
    transition: 'all 0.3s ease-in-out',
    display: 'inline-block', // Ensures proper hover effect
  },
stylingOnMouseEnter: (e) => {
e.target.style.transform = "scale(1.1) translateY(-2px)"; // Slight lift & pop effect
e.target.style.textShadow = "2px 2px 8px rgba(26, 11, 236, 0.5)"; // Soft glow effect
e.target.style.cursor = "pointer"; // Indicates it's clickable
e.target.style.color = "#083358"; // Darker shade on hover
},
stylingOnMouseLeave: (e) => {
e.target.style.transform = "scale(1) translateY(0)"; // Back to normal
e.target.style.textShadow = "none"; // Remove glow
e.target.style.color = "#0e4768"; // Reset original color
},
};
export default config;
